"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateUnderWritingReview = exports.underwritingReviewSchema = void 0;
/* eslint-disable camelcase */
var schema_validator_1 = require("@hobt/schema-validator");
var underwriting_review_delete_flag_1 = require("./underwriting-review-delete-flag");
var underwriting_review_discloser_1 = require("./underwriting-review-discloser");
exports.underwritingReviewSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['cmhcLoanAccountNumber', 'discloserIndicator'],
    properties: {
        cmhcLoanAccountNumber: {
            type: 'integer',
            maximum: 99999999,
            minimum: 1000000,
            errorMessage: 'Should be numeric between 1000000 to 99999999',
        },
        discloserIndicator: {
            type: 'integer',
            enum: Object.values(underwriting_review_discloser_1.UnderwritingReviewDiscloser),
            errorMessage: 'Should equate to a valid DiscloserIndicator Enum value',
        },
        deleteFlag: {
            type: 'integer',
            enum: Object.values(underwriting_review_delete_flag_1.UnderwritingReviewDeleteFlag),
            errorMessage: 'Should equate to a valid DeleteFlag Enum value',
        },
    },
};
exports.validateUnderWritingReview = function (data, addAuditFields) {
    if (addAuditFields === void 0) { addAuditFields = false; }
    var underwritingReviewValidator = new schema_validator_1.SchemaValidator(exports.underwritingReviewSchema, true, true, true, true);
    if (addAuditFields) {
        underwritingReviewValidator.extendSchema(schema_validator_1.auditFieldsSchema);
    }
    return underwritingReviewValidator.validate(data);
};
